module.exports = __webpack_public_path__ + "img/qx_icon6.6f9a5ceb.png";